var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.5L13.3334 12.5M13.3334 12.5C11.9527 12.5 10.8334 13.6193 10.8334 15C10.8334 16.3807 11.9527 17.5 13.3334 17.5C14.7141 17.5 15.8334 16.3807 15.8334 15C15.8334 13.6193 14.7141 12.5 13.3334 12.5ZM6.66671 7.5L6.66671 17.5M6.66671 7.5C5.28599 7.5 4.16671 6.38071 4.16671 5C4.16671 3.61929 5.286 2.5 6.66671 2.5C8.04742 2.5 9.16671 3.61929 9.16671 5C9.16671 6.38071 8.04742 7.5 6.66671 7.5Z",
    stroke: "#0D121C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.0836560f5b113aa75b17452f69e64ab1.svg";
export { ForwardRef as ReactComponent };